<div fxLayout="column" fxFlexFill style="position: relative">
  <div fxLayout="column" fxFlexFill class="spinner-container" *ngIf="dataSource.loading$ | async">
    <mat-spinner></mat-spinner>
  </div>
  <div fxFlex="auto" fxFlexFill class="table-container">

    <mat-table [dataSource]="dataSource" [multiTemplateDataRows]="true" class="regular-table responsive padding-left-10"
               matSort matSortActive="firstName" matSortDirection="desc" matSortDisableClear>
      <ng-container matColumnDef="select">
        <mat-header-cell *matHeaderCellDef>
          <mat-checkbox color="primary" (change)="$event ? masterToggle() : null"
                        [checked]="selectedRows.hasValue() && isAllSelected()"
                        [indeterminate]="selectedRows.hasValue() && !isAllSelected()">
          </mat-checkbox>
        </mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Select for edit:</span>
          <mat-checkbox color="primary" (click)="$event.stopPropagation()"
                        (change)="$event ? selectedRows.toggle(row) : null"
                        [checked]="selectedRows.isSelected(row)">
          </mat-checkbox>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="firstName">
        <mat-header-cell *matHeaderCellDef mat-sort-header="firstName">Name</mat-header-cell>
        <mat-cell *matCellDef="let row" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
          <span class="mobile-label">Name:</span>
          <a *ngIf="!readonly && ((contactService.hasPublicContactsEditAccess && row.recordType == 0)
                    || (contactService.hasPrivateContactsEditAccess && row.recordType == 1))"
             [routerLink]="[detailsUrl, row.id, 'edit']">
            {{ row.firstName }}&nbsp;{{ row.lastName }}
          </a>
          <span *ngIf="!(!readonly &&  ((contactService.hasPublicContactsEditAccess && row.recordType == 0)
                      || (contactService.hasPrivateContactsEditAccess && row.recordType == 1)))">
            {{ row.firstName }}&nbsp;{{ row.lastName }}
          </span>
          <mat-icon class="icon-20" style="color: #39CB76" *ngIf="row.syncPbx == 1" matTooltip="Synchronized with Phone System">check_circle</mat-icon>
          <mat-icon class="icon-20" color="warn" *ngIf="row.blacklisted == 1" matTooltip="Black listed on Phone System">cancel</mat-icon>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="phoneNumber">
        <mat-header-cell *matHeaderCellDef mat-sort-header="phoneNumber">Phone Number</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Phone Number:</span>
          {{ row.phoneNumber  | phoneNumber }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="mobileNumber">
        <mat-header-cell *matHeaderCellDef mat-sort-header="mobileNumber">Mobile Number</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Mobile Number:</span>
          {{ row.mobileNumber  | phoneNumber }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="faxNumber">
        <mat-header-cell *matHeaderCellDef mat-sort-header="faxNumber">Fax Number</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Fax Number:</span>
          {{ row.faxNumber  | phoneNumber }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="email">
        <mat-header-cell *matHeaderCellDef mat-sort-header="email">Email</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Email:</span>
          {{ row.email }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="companyName">
        <mat-header-cell *matHeaderCellDef mat-sort-header="companyName">Company</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Company:</span>
          {{ row.companyName }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="position">
        <mat-header-cell *matHeaderCellDef mat-sort-header="position">Title</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Title:</span>
          {{ row.position }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="recordType">
        <mat-header-cell *matHeaderCellDef mat-sort-header="recordType">Directory</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Directory:</span>
          {{ row.recordType == 0 ? 'Company' : row.recordType == 1 ? 'Private' : row.recordType == 2 ? 'Internal' : 'Unknown' }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="tags">
        <mat-header-cell *matHeaderCellDef>Tags</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Tags:</span>
          <app-tags [tags]="row.tags"></app-tags>
        </mat-cell>
      </ng-container>


      <!-- Header and Row Declarations -->
      <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns" class="call-logs-row"></mat-row>
    </mat-table>
  </div>
  <mat-paginator fxFlex="initial" [length]="dataSource.dataCount$ | async" [pageSize]="100"></mat-paginator>
</div>
